const EMBED_FLAG_KEY = "jv_auth_embed";
const EMBED_ORIGIN_KEY = "jv_auth_embed_parent_origin";
const EMBED_MODE_KEY = "jv_auth_embed_mode";

/**
 * Reads and persists WordPress iframe embed query params.
 * Keeps embed mode across in-app navigations after the query string is dropped.
 */
export function captureEmbedQueryParams() {
  if (typeof window === "undefined") {
    return null;
  }

  const params = new URLSearchParams(window.location.search);
  const embed = params.get("embed");
  if (embed === "1" || embed === "true") {
    sessionStorage.setItem(EMBED_FLAG_KEY, "1");
    const parentOrigin = params.get("origin");
    if (parentOrigin) {
      sessionStorage.setItem(EMBED_ORIGIN_KEY, parentOrigin);
    }
    const mode = params.get("mode");
    if (mode) {
      sessionStorage.setItem(EMBED_MODE_KEY, mode);
    }
  }

  return {
    isEmbed: isEmbedMode(),
    mode: getEmbedMode(),
    parentOrigin: getEmbedParentOrigin(),
  };
}

export function isEmbedMode() {
  if (typeof window === "undefined") {
    return false;
  }
  if (sessionStorage.getItem(EMBED_FLAG_KEY) === "1") {
    return true;
  }
  const params = new URLSearchParams(window.location.search);
  const embed = params.get("embed");
  return embed === "1" || embed === "true";
}

export function getEmbedMode() {
  if (typeof window === "undefined") {
    return "login";
  }
  return (
    sessionStorage.getItem(EMBED_MODE_KEY) ||
    new URLSearchParams(window.location.search).get("mode") ||
    "login"
  );
}

export function getEmbedParentOrigin() {
  if (typeof window === "undefined") {
    return "";
  }
  return (
    sessionStorage.getItem(EMBED_ORIGIN_KEY) ||
    new URLSearchParams(window.location.search).get("origin") ||
    ""
  );
}
